/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcIconComponent),
    multi: true
};

/**
 * Icon Type
 */
const IconType = {
    CLASS: "class",
    VALUE: "value"
};

/**
 * Default Icon Class
 */
const DefaultIconClass = {
    YES: "fa fa-check fa-lg",
    NO: "fa fa-times fa-lg",
    UNKNOWN: "fa fa-circle-o fa-lg"
};

/**
 * Default Icon Color
 */
const DefaultIconColor = {
    YES: "green",
    NO: "red",
    UNKNOWN: "gray"
};

/**
 * Icon
 */

export class NgcIconComponent extends ControlComponent {
     public type:string = "";
     public iconClass:string = "";
     public color:string = "";
    
    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Change
     * 
     * @param changes Change
     */
    public ngOnChanges(changes: SimpleChanges) {
        this.valueUpdateCallback();
    }

    /**
     * Calls on Value Update
     */
    public valueUpdateCallback(): void {
        if (this.type && this.value && this.type.toLowerCase() == IconType.VALUE) {
            // Update the Icon Class if Type is Value Based
            switch(this.value.toLowerCase()) {
                case "true":
                case "y":
                case "yes":
                    this.iconClass = DefaultIconClass.YES;
                    this.color = DefaultIconColor.YES;
                    break;
                case "false": 
                case "n":
                case "no":
                    this.iconClass = DefaultIconClass.NO;
                    this.color = DefaultIconColor.NO;
                    break;
                default:
                    this.iconClass = DefaultIconClass.UNKNOWN;
                    this.color = DefaultIconColor.UNKNOWN;
                    break;
            }
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-icon',
    template: `
            <i *ngIf="visible" [ngClass]="iconClass" [style.color]="color" aria-hidden="true"></i>
            `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'type': [{ type: Input, args: ["iconType", ] },],
'iconClass': [{ type: Input, args: ["iconClass", ] },],
'color': [{ type: Input, args: ["color", ] },],
};
}

/**
 * Error Module
 */

export class NgcIconModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcIconComponent],
    declarations: [NgcIconComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
